import { getPingVehicleOptions } from '@/api/main'
import { VEHICLE_PING_REFETCH_INTERVAL_MS } from '@/constants'
import { Group, MantineTheme, Tooltip, useMantineTheme } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import RippleIcon from '../RippleIcon'
import { useTranslation } from 'react-i18next'

const getRippleColor = (status: boolean | undefined, theme: MantineTheme) => {
  if (status === undefined) return theme.colors.gray[5]
  if (status) return theme.colors.green[7]
  return theme.colors.red[7]
}

const RippleRow = ({ vehicleId }: { vehicleId: string }) => {
  const theme = useMantineTheme()
  const { t } = useTranslation('vehicles')

  const { data: status } = useQuery({
    ...getPingVehicleOptions({ path: { vehicle_id: vehicleId } }),
    refetchInterval: VEHICLE_PING_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: false,
  })

  return (
    <Group styles={{ root: { gap: 'var(--spacing-xxs)' } }}>
      <Tooltip label={t('vehicleStatus')} withArrow position="top">
        <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
          <RippleIcon color={getRippleColor(status?.ping_cs, theme)} size={16} />
        </span>
      </Tooltip>
      <Tooltip label={t('modemStatus')} withArrow position="top">
        <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
          <RippleIcon color={getRippleColor(status?.ping_modem, theme)} size={16} />
        </span>
      </Tooltip>
      <Tooltip label={t('controlUnitStatus')} withArrow position="top">
        <span style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}>
          <RippleIcon color={getRippleColor(status?.ping_cu, theme)} size={16} />
        </span>
      </Tooltip>
    </Group>
  )
}

export default RippleRow
